export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      deviceTypes: [
        {
          deviceTypeUuid: 'device002',
          modelNumber: 'JS01H',
          modelName: 'XXXXBOX',
          manufacturerName: 'JEMS',
          screen_width: 1280,
          screen_height: 800,
          status: 1,
          createdAt: 1594880785395
        },
        {
          deviceTypeUuid: 'device001',
          modelNumber: 'JS01K',
          modelName: 'Hoam',
          manufacturerName: 'JEMS',
          screen_width: 1920,
          screen_height: 1080,
          status: 1,
          createdAt: 1594880785395
        }
      ]
    }
  }
}